import { ApiService } from '../core/api-service';
import { Action, Reducer } from 'redux';
import { AppThunkAction } from '.';
import authService from '../components/authorization/AuthorizeService';

export interface UserData {
    no: string;
    name: string;
    email: string;
}
export interface UserProfileState {
    email: string;
    customers: UserData[];
    embeddedPageUrl?: string;
}
interface FetchUserDetails {
    type: 'FETCH_USER_DETAILS';
    payload: UserProfileState;
}

export const actionCreators = {
    fetchUserData: (): AppThunkAction<FetchUserDetails> => async (dispatch) => {
        const user = authService.getUser();
        const apiService = new ApiService();

        if (user) {
            const data = await apiService.get(
                `protected/userProfile?username=${user.username}`
            );

            if (data) {
                dispatch({
                    type: 'FETCH_USER_DETAILS',
                    payload: {
                        email: data.email,
                        customers: data.customers || [],
                        embeddedPageUrl: data.embeddedPageUrl,
                    },
                });
            }
        }
    },
};

const unloadedState: UserProfileState = {
    email: "",
    customers: [],
    embeddedPageUrl: undefined,
};

export const reducer: Reducer<UserProfileState> = (
    state: UserProfileState = unloadedState,
    incomingAction: Action
): UserProfileState => {
    switch (incomingAction.type) {
        case 'FETCH_USER_DETAILS': {
            const action = incomingAction as FetchUserDetails;
            return action.payload;
        }
        default:
            return state;
    }
};